import * as angular from 'angular';
import { assign } from 'lodash';

import controller from './insert-filter-modal-controller';
import template from './insert-filter-modal-template.html';

interface Scope {}

const scope: Scope = {};

const options = {
  bindToController: true,
  controller,
  controllerAs: 'ctrl',
  template,
};

/**
 * Get App Injector
 *
 * Dynamically retrieve application wide injector.  The benefit of getting the application
 * injector is that it already has all custom services and dependencies registered to it
 * @inspiredby http://stackoverflow.com/questions/15527832/how-can-i-test-an-angularjs-service-from-the-console/15536532#comment22561519_15536532
 * @example
 *   class MyModule {
 *     static $inject = ['SomeAppService']
 *     constructor(SomeAppService) {
 *        this.SomeAppService = SomeAppService;
 *     }
 *     applyService(n) {
 *       return this.SomeAppService.someMethod(n);
 *     }
 *  }
 *  let $injector = getAppInjector('*[ng-app]');
 *  let module = $injector.instantiate(MyModule);
 * @param ngAppSelector
 * @returns {angular.auto.IInjectorService}
 */
export function getAppInjector(ngAppSelector = '*[mode-app]') {
  const $app = angular.element(ngAppSelector);
  const $injector: angular.auto.IInjectorService = $app.injector();

  return $injector;
}

/**
 * Spawn
 *
 * Dynamically inject {Modal} service and call opener with
 * modal properties.
 *
 * @param scopeOptions
 * @returns {{modal: any, result: Promise<any>}}
 */
function spawn(scopeOptions: Scope = {}): { modal; result: Promise<any> } {
  const newScope = assign({}, scope, scopeOptions);
  const opener = (Modal) => Modal.open(newScope, options);
  const $injector: angular.auto.IInjectorService = getAppInjector();
  const modal = $injector.invoke(['ModalService', opener]);
  const result = modal.result;

  result.catch(function () {});
  return { modal, result };
}

export { controller, Scope, template, spawn };
